import { createReducer, on } from '@ngrx/store';
import { driverLicenseActions } from '../driver_license.actions';

export interface DlCsvState {
    data: string | null;
}

export const initialState: DlCsvState = { data: null };

export const dlCsvReducer = createReducer(
    initialState,
    on(driverLicenseActions.getCSVSuccess, (state, { payload }) => ({ ...state, data: payload })),
    on(driverLicenseActions.clearCSV, () => initialState)
);
